import * as S from "./FormTitle.style";

interface FormTitleProps {
  title: string | undefined;
  text?: React.ReactElement | undefined;
}

export const FormTitle = ({ title, text }: FormTitleProps) => {
  return (
    <S.FormTitle>
      <S.Title>{title}</S.Title>
      {text && <S.ExprText>{text}</S.ExprText>}
    </S.FormTitle>
  );
};
